import { css, cx } from "emotion";
import React from "react";
import BaseLayout from "../../components/BaseLayout/BaseLayout";
import EditIcon from "@material-ui/icons/Edit";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ReconciliationStore from "../../Store/ReconciliationStore";
import { Skeleton } from "@material-ui/lab";
import { formatCurrency } from "../../components/Utils/Currency";
import moment from "moment-timezone";
import History from "../../History/History";
import ModalUpdate from "./parts/ModalUpdate";

const tableStyle = css`
  thead tr th {
    background-color: #eeeeee;
    padding: 13px 14px;
    font-size: 10px;
    font-weight: bold;
    color: #212121;
    border: none;
  }

  tbody tr {
    background-color: #ffcdd2;
    border-bottom: 1px solid #ffffff;
  }

  tbody tr td {
    padding: 13px 14px;
    font-size: 10px;
    color: #212121;
    border: none;
    vertical-align: middle;
  }
`;

const RekonsiliasiFailed = () => {
  var idLocale = require("moment/locale/id");
  moment.locale("id", idLocale);
  const [reconciliationState, reconciliationActions] = ReconciliationStore();
  const [modalUpdate, setModalUpdate] = React.useState(false);
  const [modalUpdateData, setModalUpdateData] = React.useState("");

  const toggleUpdate = (data) => {
    setModalUpdateData(data);
    setModalUpdate(!modalUpdate);
  };

  const handleGetReconciliationFailed = () => {
    reconciliationActions.getFailedReconciliation();
  };

  const handleOnUpdated = () => {
    toggleUpdate("");
    reconciliationActions.getFailedReconciliation();
  };

  React.useEffect(() => {
    const firstLoad = () => {
      handleGetReconciliationFailed();
    };

    firstLoad();
  }, []);

  return (
    <BaseLayout background="gray">
      <div className="row w-100 mx-0">
        <div className="col-12 px-0 d-flex justify-content-start align-items-center">
          <button
            type="button"
            className="btn"
            onClick={() => {
              History.push(`/rekonsiliasi`);
            }}
          >
            <ArrowBackIcon />
          </button>
          <h3 className="font-16 font-bold mb-0 mr-auto">
            Rekonsiliasi Bermasalah
          </h3>
        </div>
        <div className="col-12 px-0 mt-3">
          <div
            className={cx(
              css`
                border-radius: 8px 8px 0 0 !important;
              `,
              "card border-0"
            )}
          >
            <div className="card-body p-0 d-flex justify-content-between align-items-center">
              <h4 className="font-16 font-bold mb-0 ml-3">
                Data yang masih bermasalah
              </h4>
              <div
                className={cx(
                  css`
                    background-color: #f44336;
                    color: #ffffff;
                    text-align: right;
                    border-radius: 0 8px 0 0;
                    padding: 11px 20px;
                  `,
                  "d-flex flex-column justify-content-center align-items-end"
                )}
              >
                <span className="font-10">Total belum sama</span>
                <span className="font-bold font-16 ml-auto">
                  {reconciliationState?.isLoadingResult && (
                    <Skeleton width={50} />
                  )}
                  {!reconciliationState?.isLoadingResult &&
                    (reconciliationState?.reconciliationFailed?.length || 0)}
                </span>
              </div>
            </div>
            <div className="card-body pt-0 pr-0">
              <div className="table-responsive">
                <table className={cx(tableStyle, "table table-custom-1")}>
                  <thead>
                    <tr>
                      <th width="5%">No</th>
                      <th width="15%">Tanggal Trx</th>
                      <th width="15%">Nomor Trx</th>
                      <th width="15%">Jumlah</th>
                      <th width="25%">Note</th>
                      <th width="35%">Rekonsiliasi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!reconciliationState?.isLoadingResult &&
                      reconciliationState?.reconciliationFailed?.length > 0 &&
                      reconciliationState?.reconciliationFailed?.map(
                        (val, key) => {
                          return (
                            <tr key={key}>
                              <td align="center" width="5%">
                                {key + 1}
                              </td>
                              <td width="15%">
                                {moment(val.trx_date).format("DD/MM/YYYY")}
                              </td>
                              <td width="15%">{val.reference}</td>
                              <td width="15%">
                                {formatCurrency(
                                  process.env.REACT_APP_CURRENCY_CODE,
                                  (val.amount || 0).toString()
                                )}
                              </td>
                              <td width="25%">{val.note}</td>
                              <td width="35%">
                                <div className="w-100 d-flex justify-content-between align-items-center">
                                  <div>
                                    <span className="d-block font-bold">
                                      {moment(
                                        val.reconciliation.create_time
                                      ).format("LL")}
                                    </span>
                                    <span className="d-block">
                                      {val.reconciliation.file_url
                                        .split("/")
                                        .pop()}
                                    </span>
                                  </div>
                                  <button
                                    type="button"
                                    className={css`
                                      border: none;
                                      background-color: transparent;
                                      height: 100%;
                                    `}
                                    onClick={() => {
                                      toggleUpdate(val);
                                    }}
                                  >
                                    <EditIcon style={{ fontSize: 16 }} />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        }
                      )}
                    {reconciliationState?.isLoadingResult &&
                      Array.from(new Array(5)).map((v, k) => {
                        return (
                          <tr key={k}>
                            <td align="center" width="5%">
                              <Skeleton variant="text" animation="wave" />
                            </td>
                            <td width="15%">
                              <Skeleton variant="text" animation="wave" />
                            </td>
                            <td width="15%">
                              <Skeleton variant="text" animation="wave" />
                            </td>
                            <td width="15%">
                              <Skeleton variant="text" animation="wave" />
                            </td>
                            <td width="25%">
                              <Skeleton variant="text" animation="wave" />
                            </td>
                            <td width="35%">
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width="60%"
                              />
                              <Skeleton variant="text" animation="wave" />
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalUpdate
        modal={modalUpdate}
        toggle={toggleUpdate}
        data={modalUpdateData}
        onUpdated={handleOnUpdated}
      />
    </BaseLayout>
  );
};

export default RekonsiliasiFailed;
